// Tiny logger utility.
// - In development: prints to console for diagnostics.
// - In production: no-op, so bundled code stays clean of console statements.
//
// Use this instead of raw console.* inside catch blocks and non-critical paths.

const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  debug: isDev ? (...args) => console.debug(...args) : () => {},
  warn: isDev ? (...args) => console.warn(...args) : () => {},
  error: (...args) => console.error(...args), // always kept — real errors surface in prod monitoring
};
